module.exports = "/_next/static/images/Customer-81950954e0648b83b0b0dba37a208978.webp";